// extracted by mini-css-extract-plugin
export default {"task-column":"TaskColumn_task-column__O2LlL","task-column-body":"TaskColumn_task-column-body__oiNCV"};